import { type AppRequest } from '@autone/utils';
import { z } from 'zod';

export type ChatRequest = AppRequest<
  'agent',
  'post',
  '/agent/conversations/chat'
>;

export type ChatRequestBody = NonNullable<ChatRequest['body']>;

// The chat endpoint streams `text/event-stream`, which OpenAPI can't model
// (the generated 200 response is `unknown`), so the event shape can't be
// derived from BE types. This schema is hand-kept in sync with what the BE
// emits and validates each event at runtime before it's handled.
export const chatStreamEventSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('block_start'),
    block: z.string(),
    title: z.string().optional(),
  }),
  z.object({ type: z.literal('block_delta'), text: z.string() }),
  z.object({ type: z.literal('block_stop') }),
  z.object({ type: z.literal('error'), message: z.string() }),
]);

export type ChatStreamEvent = z.infer<typeof chatStreamEventSchema>;

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
}
